import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=56c829bd"
import script from "./IconsList.vue?vue&type=script&lang=js"
export * from "./IconsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports